import React from 'react';
import BTechPrivacy from './BTech';
import KaafiPayPrivacy from './KaafiPay';
import { API_URL } from '../../constants/api';
import Policy from './Policy';
import Rivnue from './Rivnue';

// Import the specific privacy policy components

const PrivacyPolicy = () => {
  const hostname = API_URL;

  if (hostname.includes('bulshotech')) {
    return <BTechPrivacy />;
  } else if (hostname.includes('kaafipay')) {
    return <KaafiPayPrivacy />;
  }  else if (hostname.includes('revenue') || API_URL.includes('revenue')) {
    return <Rivnue />;
  }else  {
    return <Policy />;
  } 
};

export default PrivacyPolicy;
